import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AddressTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-address-type-tbl',
  templateUrl: './address-type-tbl.component.html',
  styleUrls: ['./address-type-tbl.component.scss']
})
export class AddressTypeTblComponent implements OnChanges {

  addresstypeForm: FormGroup;
  addresstypeFormArray: FormGroup;
  control = new FormControl();
  @Input() addresstypes: AddressTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() addresstype = new EventEmitter<AddressTypeDto[]>();
  @Output() deleteAddressTypeEvent = new EventEmitter<any>();

  selectedAddressType: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createAddressTypeForm();
  }

  createAddressTypeForm() {
    this.addresstypeForm = this.fb.group({
      AddressTypeName: ['', Validators.required],
      id: null,
    });
    this.addresstypeFormArray = this.fb.group({
      AddressTypes: this.fb.array([]),
    });
    this.setAddressType();
  }

  // method to display addresstypes
  setAddressType() {
    const control = this.addresstypeFormArray.controls.AddressTypes as FormArray;
    this.addresstypes.forEach((e) => {
      control.push(
        this.fb.group({
          AddressTypeName: e.AddressTypeName,
          id: e.id,
        })
      );
    });
  }

  // method to add AddressType
  addAddressType(value: AddressTypeDto) {
    const control = this.addresstypeFormArray.controls.AddressTypes as FormArray;
    control.insert(
      0,
      this.fb.group({
        AddressTypeName: value.AddressTypeName,
        id: null,
      })
    );
  }

  selectAddressType(value) {}

  // method to delete addresstype from arrary list
  deleteAddressType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.addresstypeFormArray.controls.AddressTypes as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.addresstypes.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.addresstypes[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: AddressTypeDto) {
    if (this.addresstypeForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.addresstypeFormArray
        .get('AddressTypes')
        ['controls'][this.selectedIndex].patchValue({
          AddressTypeName: formValue.AddressTypeName,
        });
    } else {
      this.addAddressType(formValue);
    }
    this.selectedIndex = null;
    this.addresstypeForm.reset();
  }

  onEdit(index, value: AddressTypeDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.addresstypeForm.patchValue({ AddressTypeName: value.AddressTypeName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.addresstypeForm.reset();
  }

  onSubmit(formValue: AddressTypeDto[]) {
    this.addresstype.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteAddressTypeEvent.emit(this.filteredDelete);
    }
  }
}
